const State = {
  platformList: [],
  maxSortNumber: 0
}

export default State
